module.exports = __webpack_public_path__ + "img/order-off.f79d9e09.svg";